import Box from '@mui/material/Box';
import {AurLightTooltip} from '../aur-light-tooltip/aur-light-tooltip';

type AurDataGridCellWrapperProps = {
  cellData: string;
  tooltipDisabled?: boolean;
  ellipsisDisabled?: boolean;
  customCellContent?: React.ReactNode;
  className?: string;
  tooltipText?: string;
};

const AurDataGridCellWrapper: React.FC<AurDataGridCellWrapperProps> = ({
  cellData,
  tooltipDisabled = false,
  ellipsisDisabled = false,
  customCellContent,
  className = '',
  tooltipText = '',
}) => {
  const CellContent = customCellContent ?? cellData;
  const tabIndex = CellContent ? 0 : -1;

  let cellComponent = (
    <AurLightTooltip title={tooltipText || cellData} data-testid="tooltip">
      <Box className="aur-datagrid-cell-container">
        <span
          tabIndex={tabIndex}
          aria-label={tooltipText}
          className={`aur-datagrid-cell-ellipsis ${className}`}
        >
          {CellContent}
        </span>
      </Box>
    </AurLightTooltip>
  );

  if (tooltipDisabled && ellipsisDisabled) {
    cellComponent = (
      <Box className="aur-datagrid-cell-container">
        <span
          tabIndex={tabIndex}
          className={`aur-datagrid-cell-padding ${className}`}
        >
          {CellContent}
        </span>
      </Box>
    );
  } else if (tooltipDisabled) {
    cellComponent = (
      <Box className="aur-datagrid-cell-container">
        <span
          tabIndex={tabIndex}
          aria-label={tooltipText}
          className={`aur-datagrid-cell-ellipsis ${className}`}
        >
          {CellContent}
        </span>
      </Box>
    );
  } else if (ellipsisDisabled) {
    cellComponent = (
      <AurLightTooltip title={tooltipText || cellData} data-testid="tooltip">
        <Box className="aur-datagrid-cell-container">
          <span
            tabIndex={tabIndex}
            className={`aur-datagrid-cell-padding ${className}`}
          >
            {CellContent}
          </span>
        </Box>
      </AurLightTooltip>
    );
  }
  return cellComponent;
};

export default AurDataGridCellWrapper;
